<template>
  <div class="thumb">
    <a class="thumb__img" :href="this.href" v-lazy="image"></a>
    <a href="#" class="thumb__category">{{title}}</a>
  </div>
</template>

<style lang="scss">
.thumb {
  
  &__content {
    text-align: center;
  }
  &__category {
    background: $color-background-overlay;
    display: block;
    font-weight: bold;
    font-size: 14px;
    line-height: 20px;
    text-align: center;
    color: $color-link;
    padding-top: 2px;
    padding-bottom: 3px;
  }
  &:hover &__category {
    color: $color-main;
  }
}
</style>

<script>
export default {
  props: {
    title: String,
    href: String,
    image: String,
  },
  data: () => ({
    
  }),
  computed: {
    

  },
}
</script>
